export default __webpack_public_path__ + "static/media/11.f3526e7d.jpg";